// @flow

import React from 'react';
import {
  Platform,
  PanResponder,
  View,
  Dimensions,
  Animated,
  // TouchableWithoutFeedback,
  Pressable,
} from 'react-native';
import PropTypes from 'prop-types';
import styles from './styles';

type WindowDimensions = { width: number, height: number };

type Props = {
  edgeHitWidth: number,
  toleranceX: number,
  toleranceY: number,
  menuPosition: 'left' | 'right',
  onChange: Function,
  onMove: Function,
  onSliding: Function,
  openMenuOffset: number,
  hiddenMenuOffset: number,
  disableGestures: Function | bool,
  animationFunction: Function,
  onStartShouldSetResponderCapture: Function,
  isOpen: bool,
  bounceBackOnOverdraw: bool,
  autoClosing: bool
};

type Event = {
  nativeEvent: {
    layout: {
      width: number,
      height: number,
    },
  },
};

type State = {
  width: number,
  height: number,
  openMenuOffset: number,
  hiddenMenuOffset: number,
  left: Animated.Value,
};

const deviceScreen: WindowDimensions = Dimensions.get('window');

function shouldOpenMenu(dx: number): boolean {
  const deviceScreen = Dimensions.get('window');
  const barrierForward = deviceScreen.width / 4;

  return dx > barrierForward;
}

export default class SideMenu extends React.Component {
  onLayoutChange: Function;

  onStartShouldSetResponderCapture: Function;

  onMoveShouldSetPanResponder: Function;

  onPanResponderMove: Function;

  onPanResponderRelease: Function;

  onPanResponderTerminate: Function;

  state: State;

  prevLeft: number;

  isOpen: boolean;
  wasOpen: boolean;

  constructor(props: Props) {
    super(props);

    this.prevLeft = 0;
    this.isOpen = !!props.isOpen;
    this.wasOpen = props.isOpen;

    const deviceScreen = Dimensions.get('window');

    const left = this.getLeft();

    this.onLayoutChange = this.onLayout.bind(this);
    this.onStartShouldSetResponderCapture = props.onStartShouldSetResponderCapture.bind(this);
    this.onMoveShouldSetPanResponder = this.handleMoveShouldSetPanResponder.bind(this);
    this.onPanResponderMove = this.handlePanResponderMove.bind(this);
    this.onPanResponderRelease = this.handlePanResponderEnd.bind(this);
    this.onPanResponderTerminate = this.handlePanResponderEnd.bind(this);

    this.state = {
      width: deviceScreen.width,
      height: deviceScreen.height,
      openMenuOffset: props.openMenuOffset,
      hiddenMenuOffset: props.hiddenMenuOffset,
      left,
      lastOpenChange: Date.now(),
    };

    this.state.left.addListener(({ value }) => this.props.onSliding(Math.abs((value - this.state.hiddenMenuOffset) / (this.state.openMenuOffset - this.state.hiddenMenuOffset))));
    this.responder = PanResponder.create({
      onStartShouldSetResponderCapture: this.onStartShouldSetResponderCapture,
      onMoveShouldSetPanResponder: this.onMoveShouldSetPanResponder,
      onPanResponderMove: this.onPanResponderMove,
      onPanResponderRelease: this.onPanResponderRelease,
      onPanResponderTerminate: this.onPanResponderTerminate,
    });
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    // console.log('getDerivedStateFromProps');
    // console.log(`isOpen: ${prevState.isOpen} -> ${nextProps.isOpen}`);
    // console.log(`openMenuOffset: ${prevState.openMenuOffset} -> ${nextProps.openMenuOffset}`);

    if (prevState.isOpen !== nextProps.isOpen
      || prevState.openMenuOffset !== nextProps.openMenuOffset) {
      const deviceScreen = Dimensions.get('window');

      const menuPositionMultiplier = nextProps.menuPosition === 'right' ? -1 : 1;
      const offset = nextProps.isOpen
        ? nextProps.openMenuOffset * menuPositionMultiplier
        : nextProps.hiddenMenuOffset;
      nextProps
        .animationFunction(prevState.left, offset)
        .start();
      // console.log('offset');
      // console.log(offset);

      return {
        width: deviceScreen.width,
        height: deviceScreen.height,
        openMenuOffset: nextProps.openMenuOffset,
        hiddenMenuOffset: nextProps.hiddenMenuOffset,
        isOpen: nextProps.isOpen,
        lastOpenChange: Date.now(),
      };
    }

    return {
    };
  }

  onLayout(event: Object) {
    console.log('onLayout');
    const { width: prevWidth, height: prevHeight } = this.state;

    let width, height;
    if (event && event.nativeEvent && event.nativeEvent.layout) {
      console.log(event.nativeEvent.layout.width);
      console.log(event.nativeEvent.layout.height);
      width = event.nativeEvent.layout.width;
      height = event.nativeEvent.layout.height;
    }
    else {
      width = Dimensions.get('window').width;
      height = Dimensions.get('window').height;
    }

    if (width !== prevWidth || height !== prevHeight) {
      this.setState({ width, height });
    }
  }

  shouldComponentUpdate(nextProps, _nextState) {
    // console.log('shouldComponentUpdate');
    if (typeof nextProps.isOpen !== 'undefined' && this.isOpen !== nextProps.isOpen && (nextProps.autoClosing || this.isOpen === false)) {
      this.isOpen = nextProps.isOpen;
      this.wasOpen = this.wasOpen || this.isOpen;
    }
    return true;
  }

  getLeft() {
    const initialMenuPositionMultiplier = this.props.menuPosition === 'right' ? -1 : 1;
    const left: Animated.Value = new Animated.Value(
      this.props.isOpen
        ? this.props.openMenuOffset * initialMenuPositionMultiplier
        : this.props.hiddenMenuOffset,
    );

    return left;
  }

  /**
   * Get content view. This view will be rendered over menu
   * @return {React.Component}
   */
  getContentView() {
    // console.log('getContentView');
    let overlay: React.Element<void, void> = null;

    if (this.isOpen) {
      // console.log('getContentView: is open');
      overlay = (
        // <TouchableWithoutFeedback onPress={() => this.openMenu(false)}>
        <Pressable style={styles.overlay}
          onPress={() => {
            console.log('Pressable onPress');
            this.openMenu(false);
          }}
        >
          <View style={styles.overlay} />
        </Pressable>
      );
    }

    const { width, height } = this.state;
    const ref = sideMenu => (this.sideMenu = sideMenu);
    const style = [
      styles.frontView,
      { width, height },
      this.props.animationStyle(this.state.left),
    ];

    return (
      <Animated.View style={style} ref={ref} {...this.responder.panHandlers}>
        {this.props.children}
        {overlay}
      </Animated.View>
    );
  }

  moveLeft(offset: number) {
    // console.log('moveLeft');
    // console.log(offset);
    const newOffset = this.menuPositionMultiplier() * offset;

    this.props
      .animationFunction(this.state.left, newOffset)
      .start();

    this.prevLeft = newOffset;
  }

  menuPositionMultiplier(): -1 | 1 {
    const { menuPosition } = this.props;
    return menuPosition === 'right' ? -1 : 1;
  }

  handlePanResponderMove(e: Object, gestureState: Object) {
    if (this.state.left.__getValue() * this.menuPositionMultiplier() >= 0) {
      let newLeft = this.prevLeft + gestureState.dx;

      if (!this.props.bounceBackOnOverdraw && Math.abs(newLeft) > this.state.openMenuOffset) {
        newLeft = this.menuPositionMultiplier() * this.state.openMenuOffset;
      }

      this.props.onMove(newLeft);
      this.state.left.setValue(newLeft);
    }
  }

  handlePanResponderEnd(e: Object, gestureState: Object) {
    const offsetLeft = this.menuPositionMultiplier() *
      (this.state.left.__getValue() + gestureState.dx);

    this.openMenu(shouldOpenMenu(offsetLeft));
  }

  handleMoveShouldSetPanResponder(e: any, gestureState: any): boolean {
    if (this.gesturesAreEnabled()) {
      const x = Math.round(Math.abs(gestureState.dx));
      const y = Math.round(Math.abs(gestureState.dy));

      const touchMoved = x > this.props.toleranceX && y < this.props.toleranceY;

      if (this.props.isOpen) {
        return touchMoved;
      }

      const deviceScreen = Dimensions.get('window');

      const withinEdgeHitWidth = this.props.menuPosition === 'right' ?
        gestureState.moveX > (deviceScreen.width - this.props.edgeHitWidth) :
        gestureState.moveX < this.props.edgeHitWidth;

      const swipingToOpen = this.menuPositionMultiplier() * gestureState.dx > 0;
      return withinEdgeHitWidth && touchMoved && swipingToOpen;
    }

    return false;
  }

  openMenu(isOpen: boolean): void {
    const { hiddenMenuOffset, openMenuOffset, lastOpenChange } = this.state;
    const { onChange } = this.props;

    console.log('openMenu');
    console.log(isOpen);
    if (isOpen === this.isOpen) {
      return;
    }
    if (Date.now() - lastOpenChange < 250) {
      // Rate limit the toggle to 1 per second
      return;
    }
    console.log('openMenu changed');

    this.moveLeft(isOpen ? openMenuOffset : hiddenMenuOffset);
    this.isOpen = isOpen;
    this.wasOpen = this.wasOpen || isOpen;

    onChange(isOpen);
  }

  gesturesAreEnabled(): boolean {
    const { disableGestures } = this.props;

    if (typeof disableGestures === 'function') {
      return !disableGestures();
    }

    return !disableGestures;
  }

  render(): React.Element<void, void> {
    const { menuPosition, menu: propsMenu } = this.props;
    const { width, openMenuOffset } = this.state;

    // console.log('side menu render');
    // console.log(openMenuOffset);

    const boundaryStyle = menuPosition === 'right'
      ? { left: width - openMenuOffset }
      : { right: width - openMenuOffset };

    const menu = (
      <View style={[styles.menu, boundaryStyle]}>
        {this.isOpen ? propsMenu : <View style={{ flex: 1, backgroundColor: '#26272A' }} />}
      </View>
    );

    return (
      <View
        style={styles.container}
        onLayout={this.onLayoutChange}
      >
        {menu}
        {this.getContentView()}
      </View>
    );
  }
}

SideMenu.propTypes = {
  edgeHitWidth: PropTypes.number,
  toleranceX: PropTypes.number,
  toleranceY: PropTypes.number,
  menuPosition: PropTypes.oneOf(['left', 'right']),
  onChange: PropTypes.func,
  onSliding: PropTypes.func,
  onMove: PropTypes.func,
  children: PropTypes.node,
  menu: PropTypes.node,
  openMenuOffset: PropTypes.number,
  hiddenMenuOffset: PropTypes.number,
  animationStyle: PropTypes.func,
  disableGestures: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  animationFunction: PropTypes.func,
  onStartShouldSetResponderCapture: PropTypes.func,
  isOpen: PropTypes.bool,
  bounceBackOnOverdraw: PropTypes.bool,
  autoClosing: PropTypes.bool,
};

SideMenu.defaultProps = {
  toleranceY: 10,
  toleranceX: 10,
  edgeHitWidth: 60,
  children: null,
  menu: null,
  openMenuOffset: deviceScreen.width * (2 / 3),
  disableGestures: false,
  menuPosition: 'left',
  hiddenMenuOffset: 0,
  onMove: () => { },
  onStartShouldSetResponderCapture: () => true,
  onChange: () => { },
  onSliding: () => { },
  animationStyle: (value) => ({
    transform: [{
      translateX: value,
    }],
  }),
  animationFunction: (prop, value) => Animated.spring(prop, {
    toValue: value,
    friction: 8,
    useNativeDriver: Platform.OS !== 'web',
  }),
  isOpen: false,
  bounceBackOnOverdraw: true,
  autoClosing: true,
};
